import Vue from 'vue'
import { ElementControls } from './ElementControl'
// 券卡用途过滤器
Vue.filter('cardPurposeFilter', (value) => {
    if (value == 0) {
        return '直接售卡';
    } else if (value == 1) {
        return '电商售卡';
    } else if (value == 2) {
        return '分销售卡';
    }
});
// 券卡状态过滤器
Vue.filter('cardStateFilter', (value) => {
    if (value == 0) {
        return '未激活';
    } else if (value == 1) {
        return '未提货';
    } else if (value == 2) {
        return '部分提货';
    } else if (value == 3) {
        return '已提货';
    } else if (value == 4) {
        return '暂停提货';
    } else if (value == 5) {
        return '已回收';
    } else if (value == 6) {
        return '已作废';
    } else if (value == 8) {
        return '回收折现';
    }else if(value == 88){
      return '未出库';
    }
});

// 优惠券卡状态过滤器
Vue.filter('yhcardStateFilter', (value) => {
    if (value == 0) {
        return '未激活';
    } else if (value == 1) {
        return '未使用';
    } else if (value == 2) {
        return '已使用';
    } else if (value == 3) {
        return '暂停使用';
    } else if (value == 4) {
        return '已回收';
    } else if (value == 5) {
        return '已作废';
    }
});
// 消费券卡状态过滤器
Vue.filter('cardStateFilters', (value) => {
    if (value == 0) {
        return '未激活';
    } else if (value == 1) {
        return '未使用';
    } else if (value == 2) {
        return '部分使用';
    } else if (value == 3) {
        return '已使用';
    } else if (value == 4) {
        return '暂停使用';
    } else if (value == 5) {
        return '已回收';
    } else if (value == 6) {
        return '已作废';
    } else if (value == 8) {
        return '回收折现';
    }
});
// 券卡定义类型过滤器
Vue.filter('cardTypeFilter', (value) => {
    if (value == 0) {
        return '总部直接定义激活';
    } else if (value == 1) {
        return '指定门店定义激活';
    } else if (value == 2) {
        return '总部定义门店激活';
    } else if (value == 3) {
        return '总部定义后续激活';
    }
});
// 券卡支付状态过滤器
Vue.filter('cardPpayStateFilter', (value) => {
    if (value == 0) {
        return '无需付款';
    } else if (value == 1) {
        return '未付款';
    } else if (value == 2) {
        return '已付款';
    } else if (value == 3) {
        return '部分退款';
    } else if (value == 4) {
        return '已退款';
    } else if (value == 5) {
        return '已取消';
    }else{
        return '--'
    }
});
// 优惠券状态过滤器
Vue.filter('couponStateFilter', (value) => {
    if (value == 0) {
        return '未激活';
    } else if (value == 1) {
        return '未使用';
    } else if (value == 2) {
        return '已使用';
    } else if (value == 3) {
        return '暂停使用';
    } else if (value == 4) {
        return '已回收';
    } else if (value == 5) {
        return '已作废';
    }
});
// 优惠券用途过滤器
Vue.filter('couponPurposeFilter', (value) => {
    if (value == 0) {
        return '总部发放';
    } else if (value == 1) {
        return '商城领券中心';
    } else if (value == 2) {
        return '礼包发放';
    } else if (value == 3) {
        return '积分兑换';
    } else if (value == 4) {
        return '游戏奖品';
    } else if (value == 5) {
        return '公众号推送';
    }
});
// 优惠券类型过滤器
Vue.filter('couponTypeFilter', (value) => {
    if (value == 0) {
        return '满减券';
    } else if (value == 1) {
        return '运费券';
    } else if (value == 2) {
        return '现金券';
    } else if (value == 3) {
        return '折扣券';
    }
});
// 券卡操作类型过滤器
Vue.filter('cardOpertypeFilter', (value, opesource,cardmedium) => {
    if(cardmedium==1){
      if(value == 2){
        return '暂停使用';
      }else if(value == 3){
        return '恢复使用';
      }else if (value == 4) {
        return '回收';
      } else if (value == 5) {
          return '作废';
      } else if (value == 6) {
          return '卡包回收';
      } else if (value == 7) {
          return '卡包修改';
      } else if (value == 8) {
          return '后续分销';
      } else if (value == 9) {
          return '回收折现';
      } else if (value == 10) {
          return '快捷修改';
      } else if (value == 11) {
          return '修改';
      } else if (value == 12) {
          return '现金收款';
      } else if (value == 13) {
          return '分销回收';
      }else{
          return '电子券出库';
        }
    }else if (value == 0) {
        if (opesource == 1) {
            return '定义激活'; // 或分销
        } else {
            return '出库'; // 或分销
        }
    } else if (value == 1) {
        return '激活';
    } else if (value == 2) {
        return '暂停使用';
    } else if (value == 3) {
        return '恢复使用';
    } else if (value == 4) {
        return '回收';
    } else if (value == 5) {
        return '作废';
    } else if (value == 6) {
        return '卡包回收';
    } else if (value == 7) {
        return '卡包修改';
    } else if (value == 8) {
        return '后续分销';
    } else if (value == 9) {
        return '回收折现';
    } else if (value == 10) {
        return '快捷修改';
    } else if (value == 11) {
        return '修改';
    } else if (value == 12) {
        return '现金收款';
    } else if (value == 13) {
        return '分销回收';
    } else if (value == 14) {
      return '门店铺券';
    }else if(value == 15){
      return '门店销售回收';
    }
});
// 返利层级过滤器
Vue.filter('rebateRankFilter', (value) => {
    if (!value || value === 0) {
        return '无需返利';
    } else if (value == 1) {
        return '一级返利';
    } else if (value == 2) {
        return '二级返利';
    }
});
// 返利状态过滤器
Vue.filter('rebateStateFilter', (value) => {
    if (value == 0) {
        return '无需结算';
    } else if (value == 1) {
        return '待结算';
    } else if (value == 2) {
        return '已结算';
    }
});
// 订单状态过滤器
Vue.filter('orderStateFilter', (value) => {
    if (value == 0) {
        return '待付款';
    } else if (value == 1) {
        return '待处理';
    } else if (value == 2) {
        return '已退款';
    } else if (value == 3) {
        return '配货中';
    } else if (value == 4) {
        return '部分发货';
    } else if (value == 5) {
        return '已发货';
    } else if (value == 6) {
        return '正常结单';
    } else if (value == 7) {
        return '问题结单';
    } else if (value == 8) {
        return '订单取消';
    } else if (value == 9) {
        return '订单取消待审核';
    }
});
// 订单类型过滤器
Vue.filter('orderTypeFilter', (value) => {
  if (value == 0) {
    return '券卡提货';
  } else if (value == 1) {
      return '商城购买';
  } else if (value == 2) {
      return '补发订单';
  } else if (value == 3) {
      return '鲜度码购买';
  } else if (value == 5) {
      return '销售下单';
  }else if(value == 6){
    return '福采现货下单';
  }
});
// 商品类型过滤器
Vue.filter('goodsTypeFilter', (value) => {
    if (value == 0) {
        return '实物商品';
    } else if (value == 1) {
        return '实体券卡';
    } else if (value == 2) {
        return '电子券卡';
    }
});
// 终端类型过滤器
Vue.filter('terminalTypeFilter', (value) => {
    if (value == 0) {
        return 'PC';
    } else if (value == 1) {
        return '手机';
    } else if (value == 2) {
        return '微信';
    }
});
// 提货方式
Vue.filter('delimodeFilter', (value) => {
    if (value == 0) {
        return '自提';
    } else if (value == 1) {
        return '送货'
    }
});
// 提货方式
Vue.filter('delimodeAdvanceFilter', (value, goodstype, recivername, ordertype) => {
    if (value === 0 && ordertype === 5) {
        return "到店自提";
    }
    if (value == 0) {
        if (goodstype === 2) {
            return "电子卡"
        }
        if (recivername) {
            return '预约自提';
        }

        return '到店自提';
    } else if (value == 1) {
        return '送货'
    }
});
// 订单来源过滤器
Vue.filter('prosourceFilter', (value) => {
    if (value == 0) {
        return '总部';
    } else if (value == 1) {
        return '门店';
    } else if (value == 2) {
        return '消费者';
    } else if (value == 3) {
        return '外部对接';
    } else if (value == 4) {
        return '仓分享合作';
    }else if(value == 5){
      return '云仓合作';
    }
});
// 派单状态过滤器
Vue.filter('desStateFilter', (value) => {
    if (value == 0) {
        return '未派单';
    } else if (value == 1) {
        return ElementControls('erjimendian')!=1?'派单完成':'总部派单';
    } else if (value == 2) {
        return '派单退回';
    } else if (value == 3) {
        return '派单取消';
    } else if (value == 4) {
        return '派单中';
    }
});
// 拆单状态过滤器
Vue.filter('seporderStateFilter', (value) => {
    if (value == 0) {
        return '无需拆单';
    } else if (value == 1) {
        return '待拆单';
    } else if (value == 2) {
        return '已完成';
    }
});
// 开票状态过滤器
Vue.filter('makeinvStateFilter', (value) => {
    if (value == 0) {
        return '无需开票';
    } else if (value == 1) {
        return '待开票';
    } else if (value == 2) {
        return '开票完成';
    }
});
// 积分领取状态过滤器
Vue.filter('igetStateFilter', (value) => {
    if (value == 0) {
        return '无积分奖励';
    } else if (value == 1) {
        return '待领取';
    } else if (value == 2) {
        return '已领取';
    }
});
// 互动游戏活动状态过滤器
Vue.filter('interactivityStateFilter', (value) => {
    if (value == 0) {
        return '无营销活动';
    } else if (value == 1) {
        return '待参与';
    } else if (value == 2) {
        return '已参与';
    }
});
// 晒单状态过滤器
Vue.filter('evaorderStatusFilter', (value) => {
    if (value == 0) {
        return '待评价';
    } else if (value == 1) {
        return '待晒单';
    } else if (value == 2) {
        return '已晒单';
    }
});
// 订单归属过滤器
Vue.filter('operpOwerFilter', (value) => {
    if (value == 0) {
        return '总部';
    } else if (value == 1) {
        return '门店';
    } else if (value == 2) {
        return '发货网点';
    } else if (value == 3) {
        return '分销商';
    }
});
// 支付方式过滤器
Vue.filter('paySuccessFilter', (value) => {
    if (value == 0) {
        return "现金支付";
      } else if (value == 1) {
        return "支付宝";
      } else if (value == 2) {
        return "微支付";
      } else if (value == 3) {
        return "银联支付";
      }else if(value == 4){
        return "合作扣除"
      }else if(value == 5){
        return "商城币支付"
      } else{
        return "--"
      }
});
// 订单支付状态过滤器
Vue.filter('payStatusFilter', (value) => {
    if (value === 0 || !value) {
        return '无需付款';
    } else if (value == 1) {
        return '未付款';
    } else if (value == 2) {
        return '已付款';
    } else if (value == 3) {
        return '已退款';
    } else if (value == 4) {
        return '退款中';
    } else if (value == 5) {
        return '退款失败';
    }
});
// 支付方类型过滤器
Vue.filter('payerTypeFilter', (value) => {
    if (value == 0) {
        return '总部';
    } else if (value == 1) {
        return '门店';
    } else if (value == 2) {
        return '消费者';
    } else if (value == 3) {
      return '仓分享合作企业';
    } else if (value == 4) {
      return '云仓合作企业';
    }
});
// 订单操作类型过滤器
Vue.filter('orderOperTypeFilter', (value) => {
    if (value == 0) {
        return '普通修改';
    } else if (value == 1) {
        return '高级修改';
    } else if (value == 2) {
        return '订单取消';
    } else if (value == 3) {
        return '订单派单';
    } else if (value == 4) {
        return '派单退回';
    } else if (value == 5) {
        return '取消派单';
    } else if (value == 6) {
        return '手动拆单';
    } else if (value == 7) {
        return '修改备注';
    } else if (value == 8) {
        return '修改金额';
    } else if (value == 9) {
        return '修改期望发货日期';
    } else if (value == 10) {
      return '转快递发货';
    } else if (value == 11) {
      return '转门店自提';
    } else if (value == 12) {
        return '订单取消申请';
    } else if (value == 13) {
        return '撤回订单取消申请';
    }
});
// 分销支付方类型过滤器
Vue.filter('resellPayerTypeFilter', (value) => {
    if (value == 0) {
        return '总部';
    } else if (value == 1) {
        return '一级分销商';
    } else if (value == 2) {
        return '二级分销商';
    } else if (value == 3) {
        return '消费者';
    }
});
// 分销支付方方式
Vue.filter('resellPayerWayFilter', (value) => {
    if (value == 0) {
        return '现金支付';
    } else if (value == 1) {
        return '支付宝';
    } else if (value == 2) {
        return '微支付';
    } else if (value == 3) {
        return '银联支付';
    } else if (value == 4) {
        return "余额抵扣";
    }
});
// 快递处理方式过滤器
Vue.filter('handleTypeFilter', (value) => {
  if (value == 1000) {
    return '针式打印';
  } else if (value == 1) {
    return '顺丰热敏';
  } else if (value == 90) {
    return '京东热敏';
  } else if (value == 1001) {
    return '导出即发货';
  } else if (value == 1002) {
    return '导出待发货';
  } else if (value == 1003) {
    return '百盛ERP对接';
  } else if (value == 1004) {
    return '管易ERP对接';
  } else if (value == 1006) {
    return '旺店通ERP对接';
  } else if (value == 79) {
    return '韵达热敏';
  } else if (value == 110) {
    return '菜鸟热敏';
  } else if (value == 97) {
    return '安能热敏';
  } else if (value == 40) {
    return '联邦热敏';
  } else if (value == 100) {
    return '跨越热敏';
  } else if (value == 2) {
    return '圆通热敏';
  } else if (value == 107) {
    return '京东云仓';
  } else if (value == 1005) {
    return 'E店宝';
  } else if (value == 1007) {
    return '网店管家';
  } else if (value == 111) {
    return '承诺达';
  } else if (value == 1009) {
    return '金蝶ERP对接';
  } else if (value == 1010) {
    return '聚水潭ERP对接';
  } else if (value == 137) {
    return '京东快运';
  } else if (value == 1014) {
    return '畅捷通ERP对接';
  } else if (value == 150) {
    return '京东';
  } else if (value == 1015) {
     return '菜鸟速递';
  }else{
    return '--';
  }
});
// 发货状态过滤器
Vue.filter('deliverStateFilter', (value) => {
    if (value == 0) {
        return '待发货';
    } else if (value == 1) {
        return '已发货';
    } else if (value == 2) {
        return '退货';
    } else if (value == 3) {
        return '已补发';
    } else if (value == 4) {
        return '无效快递';
    } else if (value == 5) {
      return '已签收';
    } else if (value == 6) {
      return '异常签收';
    }
});
// 筛单状态过滤器
Vue.filter('screenStateFilter', (value) => {
    if (value == 0) {
        return '待筛单';
    } else if (value == 1) {
        return '筛单处理成功';
    } else if (value == 2) {
        return '筛单处理失败';
    } else if (value == 4) {
        return '筛单处理异常';
    } else {
        return "待筛单";
    }
});
// 筛单状态色过滤器
Vue.filter('screenStateColorFilter', (value) => {
  if (value == 0) {
      return 'orangeColor';
  } else if (value == 1) {
      return 'greenColor';
  } else if (value == 2 || value == 4) {
      return 'redColor';
  }else {
      return "orangeColor";
  }
});
// 快递操作来源过滤器
Vue.filter('delOpesourceFilter', (value) => {
    if (value == 0) {
        return '总部';
    } else if (value == 1) {
        return '经销商';
    } else if (value == 2) {
        return '发货网点';
    } else if (value == 3) {
        return '分销商';
    }
});
// 快递生成类型过滤器
Vue.filter('expgenTypeFilter', (value) => {
    if (value == 0) {
        return '按订单生成';
    } else if (value == 1) {
        return '按券卡生成';
    } else if (value == 2) {
        return '按商品生成';
    } else if (value == 3) {
        return '合并快递';
    } else if (value == 4) {
        return '外部导入';
    }
});
// 快递处理状态过滤器
Vue.filter('handleStatusFilter', (value) => {
    if (value == 0) {
        return '待处理';
    } else if (value == 1) {
        return '发卡订单处理';
    } else if (value == 2) {
        return '发货订单处理';
    }
});
// 店铺类型过滤器
Vue.filter('jdplatWayFilter', (value) => {
    if (value == 0) {
        return 'pop';
    } else if (value == 1) {
        return '自营入仓';
    } else if (value == 2) {
        return 'FBP自营入仓';
    }
});
// 快递订单状态过滤器
Vue.filter('delOrderStateFilter', (value) => {
    if (value == 0) {
        return '待发卡';
    } else if (value == 1) {
        return '已发卡';
    } else if (value == 2) {
        return '兑换锁定';
    } else if (value == 3) {
        return '正常结单';
    } else if (value == 4) {
        return '订单取消';
    } else if (value == 5) {
        return '未打印待发卡';
    } else if (value == 6) {
        return '待打印待发卡';
    }
});
// 生码状态过滤器
Vue.filter('GencoderecordListState', (value) => {
    if (value == 0) {
        return '生码中';
    } else if (value == 1) {
        return '生码完成待下载';
    } else if (value == 2) {
        return '已下载';
    } else if (value == 3) {
        return '生码失败';
    } else {
        return '--'
    }
});
// 商品类型
Vue.filter('GoodsList', (value) => {
    if (value == 0) {
        return '实物商品';
    } else if (value == 1) {
        return '礼品券卡';
    } else if (value == 2) {
        return '充值卡';
    } else {
        return '--'
    }
});
// 活动状态
Vue.filter('PromotionStatus', (value) => {
    if (value == 0) {
        return '未开始';
    } else if (value == 1) {
        return '正在进行';
    } else if (value == 2) {
        return '已结束';
    } else if (value == 3) {
        return '已取消';
    } else {
        return '--'
    }
});
// 合作状态过滤器
Vue.filter('collaborateState', (value) => {
    if (value == 0) {
        return '待审核';
    } else if (value == 1) {
        return '合作中';
    } else if (value == 2) {
        return '审核失败';
    } else if (value == 3) {
        return '合作已解除';
    }
});
//会员级别
Vue.filter('mlevelState', (value) => {
    if (value == 0) {
        return '新手会员';
    } else if (value == 1) {
        return 'VIP1';
    } else if (value == 2) {
        return 'VIP2';
    } else if (value == 3) {
        return 'VIP3';
    } else if (value == 4) {
        return 'VIP4';
    }
});
Vue.filter('msgTypeFilter', (value) => {
    if (value == 0) {
        return '普通消息';
    } else if (value == 1) {
        return '商品推荐';
    } else if (value == 2) {
        return '互动游戏';
    }
});
// 需求信息发布状态过滤器
Vue.filter('releaseState', (value) => {
    if (value == 0) {
        return '待审核';
    } else if (value == 1) {
        return '发布中';
    } else if (value == 2) {
        return '已结束';
    } else if (value == 3) {
        return '审核失败';
    }
});
// 充值通道
Vue.filter('rectype', (value) => {
    if (value == 0) {
        return '平台直接充值';
    } else if (value == 1) {
        return '企业在线充值';
    } else if (value == 2) {
        return '营销订单付款';
    }
});
// 投诉状态过滤器
Vue.filter('complaintState', (value) => {
    if (value == 0) {
        return '待处理';
    } else if (value == 1) {
        return '处理中';
    } else if (value == 2) {
        return '已妥善处理';
    } else if (value == 3) {
        return '异常处理';
    }
});
/**
 * 营销互动
 */
// 活动状态
Vue.filter('actState', (value) => {
    if (value == 0) {
        return '未开始';
    } else if (value == 1) {
        return '进行中';
    } else if (value == 2) {
        return '已暂停';
    } else if (value == 3) {
        return '已结束';
    }
});

// 数字转汉字
Vue.filter('numToChinse', (num, text) => {
    let value = 0;
    if (num == 0) {
        value = '零';
    }
    if (num == 1) {
        value = '一';
    }
    if (num == 2) {
        value = '二';
    }
    if (num == 3) {
        value = '三';
    }
    if (num == 4) {
        value = '四';
    }
    if (num == 5) {
        value = '五';
    }
    if (num == 6) {
        value = '六';
    }
    if (num == 7) {
        value = '七';
    }
    if (num == 8) {
        value = '八';
    }
    if (num == 9) {
        value = '九';
    }

    return text ? text.replace("{num}", value) : value;

});
Vue.filter('giftType', (value) => {
    if (value == 0) {
        return '实物';
    } else if (value == 1) {
        return '话费';
    } else if (value == 2) {
        return '流量';
    } else if (value == 3) {
        return '积分';
    } else if (value == 4) {
        return '商城币';
    } else if (value == 5) {
        return '微信红包';
    }
});
Vue.filter('parchannel', (value) => {
    if (value == 0) {
        return '券卡兑换';
    } else if (value == 1) {
        return '商城购买';
    } else if (value == 2) {
        return '商品溯源';
    } else if (value == 3) {
        return '会员签到';
    } else if (value == 4) {
        return '积分参与游戏';
    } else if (value == 5) {
        return '活动推广互动';
    } else if (value == 6) {
        return '有奖售后';
    }
});
Vue.filter('marorderstate', (value) => {
    if (value == 0) {
        return '待付款';
    } else if (value == 1) {
        return '已付款/待处理';
    } else if (value == 2) {
        return '已退款';
    } else if (value == 3) {
        return '配货中';
    } else if (value == 4) {
        return '已发货';
    } else if (value == 5) {
        return '正常结单';
    } else if (value == 6) {
        return '问题结单';
    } else if (value == 7) {
        return '订单取消';
    }
});
Vue.filter('marorderpaysuccess', (value) => {
    if (value == 0) {
        return '现金支付';
    } else if (value == 1) {
        return '支付宝支付';
    } else if (value == 2) {
        return '微信支付';
    } else if (value == 3) {
        return '银联支付';
    }
});
Vue.filter('marordersetstatus', (value) => {
    if (value == 0) {
        return '无需结算';
    } else if (value == 1) {
        return '待结算';
    } else if (value == 2) {
        return '已结算';
    }
});
Vue.filter('marorderpaystatus', (value) => {
    if (value == 0) {
        return '无需付款';
    } else if (value == 1) {
        return '待付款';
    } else if (value == 2) {
        return '已付款';
    } else if (value == 3) {
        return "已退款";
    }
});

/** 售后服务 **/
// 退换货申请状态
Vue.filter('returnapplication', (value) => {
    if (value == 0) {
        return '待审核';
    } else if (value == 1) {
        return '审核通过';
    } else if (value == 2) {
        return '审核不通过';
    } else if (value == 3) {
        return "已处理";
    }
});
// 商品评价状态
Vue.filter('goodsevarecordsStatus', (value) => {
    if (value == 0) {
        return '已评价';
    } else if (value == 1) {
        return '已追评';
    } else if (value == 2) {
        return '已屏蔽';
    }
});
// 有奖售后活动参与状态
Vue.filter('interactivitystateStatus', (value) => {
    if (value == 0) {
        return '无营销活动';
    } else if (value == 1) {
        return '待参与';
    } else if (value == 2) {
        return '已参与';
    }
});
// 提现申请状态
Vue.filter('withdrawalrecordsStatus', (value) => {
    if (value == 0) {
        return '待审核';
    } else if (value == 1) {
        return '审核通过，待处理';
    } else if (value == 2) {
        return '审核通过，已处理';
    } else if (value == 3) {
        return '审核不通过';
    }
});
// 快递补发申请状态
Vue.filter('resendapplicationStatus', (value) => {
    if (value == 0) {
        return '待审核';
    } else if (value == 1) {
        return '审核通过';
    } else if (value == 2) {
        return '已拒绝';
    }
});
Vue.filter('payStatusFilteryx', (value) => {
    if (value === 0 || !value) {
        return '待付款';
    } else if (value == 1) {
        return '已付款';
    } else if (value == 2) {
        return '已退款';
    } else if (value == 3) {
        return '配货中';
    } else if (value == 4) {
        return '已发货';
    } else if (value == 5) {
        return '正常结单';
    } else if (value == 6) {
        return '问题结单';
    } else if (value == 7) {
        return '订单取消';
    }
});
Vue.filter('anntypesfiler', (value) => { //公告
    if (value == 0) {
        return '维护';
    } else if (value == 1) {
        return '升级';
    } else if (value == 2) {
        return '推广';
    } else if (value == 3) {
        return '其它';
    } else {
        return '---'
    }
});

// 销售单状态
Vue.filter('saleOrderStateFilter', (value) => {
    if (value == 0) {
        return "待处理";
    } else if (value == 1) {
        return "部分发货";
    } else if (value == 2) {
        return "已完成";
    } else if (value == 3) {
        return "正常结单";
    } else if (value == 4) {
        return "问题结单";
    } else if (value == 5) {
        return "已取消";
    } else if (value == 6) {
        return "待审核";
    } else if (value == 7) {
        return "销售发货";
    } else if (value == 8) {
        return "退货完成";
    }
});
// 销售单付款状态
Vue.filter('saleOrderPayStateFilter', (value) => {
    if (value == 0) {
        return "待付款";
    } else if (value == 1) {
        return "已付款";
    } else if (value == 2) {
        return "部分退款";
    } else if (value == 3) {
        return "全部退款";
    } else if (value == 4) {
        return "无需付款"
    }
});
// 销售单消费者付款状态
Vue.filter('saleOrderConsumerPayStateFilter', (value) => {
    if (value == 0) {
        return "待收款";
    } else if (value == 1) {
        return "全部收款";
    } else if (value == 2) {
        return "部分退款";
    } else if (value == 3) {
        return "全部退款";
    } else if (value == 4) {
        return "部分收款";
    } else if (value == 5) {
        return "无需收款";
    }
});
// 销售单商品类型
Vue.filter('saleOrderGoodsTypeFilter', (value) => {
    if (value == 0) {
        return "实物商品";
    } else if (value == 1) {
        return "礼品券卡";
    }
});
// 销售单终端类型
Vue.filter('saleOrderTerminaltypeFilter', (value) => {
    if (value == 0) {
        return "PC";
    } else if (value == 1) {
        return "手机";
    }
});
//额度记录类型
Vue.filter('typeFilters', (value) => {
        if (value == 0) {
            return "提升额度";
        } else if (value == 1) {
            return "降低额度";
        } else if (value == 2) {
            return "账单还款";
        } else if (value == 3) {
            return "账单退款";
        } else if (value == 4) {
            return "交易扣除";
        } else if (value == 5) {
            return "交易退款";
        }
    })
    // 销售单-券卡状态
Vue.filter('saleOrderCardPaystatusFilter', (value) => {
        if (value == 0) {
            return "已付款";
        } else if (value == 1) {
            return "已申请退款";
        } else if (value == 2) {
            return "已退款，卡已作废";
        } else if (value == 3) {
            return "已退款，卡已收回";
        } else if (value == 4) {
            return "待付款";
        } else if (value == 5) {
            return "未付款，已收回";
        }
    })
    //金世尊导入发货状态
Vue.filter('deliverGoodsState', (value) => {
        if (value == 0) {
            return "待生成";
        } else if (value == 1) {
            return "已生成";
        } else if (value == 2) {
            return "生成失败";
        } else {
            return "--";
        }
    })
    //发货申请状态
Vue.filter('deilverapplystatus', (value) => {
    if (value == 0) {
        return "待申请";
    } else if (value == 1) {
        return "部分申请";
    } else if (value == 2) {
        return "已申请";
    } else {
        return "--";
    }
})
//销售单退货状态
Vue.filter('returnstatusFilter', (value) => {
    if (value == 0) {
        return "无退货";
    } else if (value == 1) {
        return "部分退货";
    } else if (value == 2) {
        return "全部退货";
    } else {
        return "--";
    }
})
//达达订单状态
Vue.filter('statusDadaFilter', (val) => {
  if(val==1){
    return '待接单'
 }else if(val==2){
    return '待取货'
 }else if(val==3){
    return '配送中'
 }else if(val==4){
    return '已完成'
 }else if(val==5){
    return '已取消'
 }else if(val==8){
    return '指派单'
 }else if(val==9){
    return '妥投异常之物品返回中'
 }else if(val==10){
    return '妥投异常之物品返回完成'
 }else if(val==100){
    return '骑士到店'
 }else if(val==1000){
    return '创建达达运单失败'
 }else{
    return '--'
 }
})
// 达达订单状态过滤器
Vue.filter('ddorderStateFilter', (ordstate,ddorderstate) => {
  if(ordstate==0){
  return '待付款'
  }else if(ordstate==1){
  return '待处理'
  }else if (ordstate == 2) {
  return '已退款';
  } else if (ordstate == 3) {
  return '配货中';
  } else if (ordstate == 4) {
  return '部分发货';
  } else if (ordstate == 5) {
  return '已发货';
  } else if (ordstate == 6) {
  return '正常结单';
  } else if (ordstate == 7) {
  return '问题结单';
  } else if (ordstate == 8) {
  return '订单取消';
  }
});



// WEBPACK FOOTER //
// ./src/util/stateORtypeFilter.js